import { lazy } from 'react'
import authRoute from './authRoute'
import othersRoute from './othersRoute'
import type { Routes } from '@/@types/routes'

export const publicRoutes: Routes = [...authRoute]

export const protectedRoutes: Routes = [
    // {
    //     key: 'home',
    //     path: '/home',
    //     component: lazy(() => import('@/views/Home')),
    //     authority: [],
    // },
    {
        key: 'orgchart',
        path: '/employee/hierarchy',
        component: lazy(() => import('@/views/hradmin/OrgChart')),
        authority: [],
    },
    {
        key: 'basicdetails',
        path: '/basicdetails',
        component: lazy(() => import('@/views/BasicDetails')),
        authority: [],
    },

    {
        key: 'basicdetails',
        path: '/basicdetails/view',
        component: lazy(() => import('@/views/profile/BasicDetailsView')),
        authority: [],
    },

    {
        key: 'basicdetails',
        path: '/basicdetails/edit',
        component: lazy(() => import('@/views/profile/BasicDetailsEdit')),
        authority: [],
    },

    {
        key: 'familydetails',
        path: '/familydetails',
        component: lazy(() => import('@/views/PersonalDetails')),
        authority: [],
    },
    {
        key: 'familydetails',
        path: '/familydetails/view',
        component: lazy(() => import('@/views/profile/FamilyDetailsView')),
        authority: [],
    },
    {
        key: 'familydetails.edit',
        path: '/familydetails/edit',
        component: lazy(() => import('@/views/profile/FamilyDetailsEdit')),
        authority: [],
    },
    {
        key: 'education',
        path: '/education',
        component: lazy(() => import('@/views/Education')),
        authority: [],
    },
    {
        key: 'employment',
        path: '/employment',
        component: lazy(() => import('@/views/Employment')),
        authority: [],
    },
    {
        key: 'passportdetails',
        path: '/passportdetails',
        component: lazy(() => import('@/views/PassportDetails')),
        authority: [],
    },
    {
        key: 'bank',
        path: '/bank',
        component: lazy(() => import('@/views/Bank')),
        authority: [],
    },
    {
        key: 'bankdetails',
        path: '/bankdetails/view',
        component: lazy(() => import('@/views/profile/BankDetailsView')),
        authority: [],
    },
    {
        key: 'bankdetails.edit',
        path: '/bankdetails/edit',
        component: lazy(() => import('@/views/profile/BankDetailsEdit')),
        authority: [],
    },
    {
        key: 'address',
        path: '/address',
        component: lazy(() => import('@/views/Address')),
        authority: [],
    },
    {
        key: 'address',
        path: '/address/view',
        component: lazy(() => import('@/views/profile/AddressView')),
        authority: [],
    },
    {
        key: 'address.edit',
        path: '/address/edit',
        component: lazy(() => import('@/views/profile/AddressEdit')),
        authority: [],
    },
    {
        key: 'emergencyContact',
        path: '/emergencycontact',
        component: lazy(() => import('@/views/EmergencyContact')),
        authority: [],
    },
    {
        key: 'emergencyContact',
        path: '/emergencycontact/view',
        component: lazy(() => import('@/views/profile/EmergencyContactView')),
        authority: [],
    },
    {
        key: 'emergencyContact.edit',
        path: '/emergencycontact/edit',
        component: lazy(() => import('@/views/profile/EmergencyContactEdit')),
        authority: [],
    },
    {
        key: 'techProfile',
        path: '/techprofile',
        component: lazy(() => import('@/views/TechProfile')),
        authority: [],
    },
    // {
    //     key: 'outpassRequest',
    //     path: '/outpassrequest',
    //     component: lazy(() => import('@/views/OutpassRequest')),
    //     authority: [],
    // },
    // {
    //     key: 'leaveApplication',
    //     path: '/leaveapplication',
    //     component: lazy(() => import('@/views/LeaveApplication')),
    //     authority: [],
    // },
    {
        key: 'MdNewDashboard1',
        path: '/dashboard/mdnewdashboard',
        component: lazy(() => import('@/views/dashboard/MdNewDashboard')),
        authority: [],
    },
    // {
    //     key: 'mdDashboard',
    //     path: '/dashboard/mdnewdashboard',
    //     component: lazy(() => import('@/views/dashboard/MdNewDashboard')),
    //     authority: [],
    // },
    {
        key: 'HrDashboard',
        path: '/dashboard/hrdashboard',
        component: lazy(() => import('@/views/dashboard/HrDashboard')),
        authority: [],
    },
    {
        key: 'HrDashboard.Attendance',
        path: '/dashboard/hrdashboard/attendance',
        component: lazy(() => import('@/views/dashboard/Attendance')),
        authority: [],
    },
    {
        key: 'HrDashboard.EmpPhoto',
        path: '/dashboard/hrdashboard/empphoto',
        component: lazy(() => import('@/views/dashboard/EmployeePhoto')),
        authority: [],
    },
    {
        key: 'HrDashboard.BirthdayWishes',
        path: '/dashboard/hrdashboard/birthdaywish',
        component: lazy(
            () => import('@/views/dashboard/BirthdayAnniversaryWishes'),
        ),
        authority: [],
    },
    {
        key: 'HrDashboard.BirthdayWishesv2',
        path: '/dashboard/hrdashboard/birthdaywishv2',
        component: lazy(
            () => import('@/views/dashboard/BirthdayAnniversaryWishesV2'),
        ),
        authority: [],
    },
    {
        key: 'HrDashboard.BirthdayWishesv2',
        path: '/dashboard/hrdashboard/birthdaywishv3',
        component: lazy(
            () => import('@/views/dashboard/BirthdayAnniversaryWishesV3'),
        ),
        authority: [],
    },
    {
        key: 'HrDashboard.LikesAndComments',
        path: '/dashboard/hrdashboard/comments',
        component: lazy(() => import('@/views/dashboard/LikesAndComments')),
        authority: [],
    },
    {
        key: 'HrDashboard.LikesAndCommentsv2',
        path: '/dashboard/hrdashboard/commentsv2',
        component: lazy(() => import('@/views/dashboard/LikesAndCommentsv2')),
        authority: [],
    },
    {
        key: 'schedulemeetingList',
        path: '/schedulemeeting/list',
        component: lazy(() => import('@/views/meeting/ListScheduleMeeting')),
        authority: [],
    },
    {
        key: 'schedulemeeting',
        path: '/schedulemeeting',
        component: lazy(() => import('@/views/meeting/ScheduleMeeting')),
        authority: [],
    },
    {
        key: 'schedulemeetingView',
        path: '/schedulemeeting/view',
        component: lazy(() => import('@/views/meeting/ViewScheduleMeeting')),
        authority: [],
    },
    {
        key: 'MdNewDashboard',
        path: '/dashboard/mddashboard',
        component: lazy(() => import('@/views/dashboard/MdNewDashboard')),
        authority: [],
    },
    {
        key: 'approvalList',
        path: '/approval/list',
        component: lazy(() => import('@/views/dashboard/ListApproval')),
        authority: [],
    },
    {
        key: 'empDashboard',
        path: '/dashboard/empdashboard',
        component: lazy(() => import('@/views/EmpDashboard')),
        authority: [],
    },
    {
        key: 'teamDashboard',
        path: '/dashboard/teamdashboard',
        component: lazy(() => import('@/views/dashboard/TeamDashboard')),
        authority: [],
    },
    {
        key: 'newMdDashboard',
        path: '/dashboard/newmddashboard',
        component: lazy(() => import('@/views/dashboard/NewMdDashboard')),
        authority: [],
    },

    {
        key: 'salesDashboard',
        path: '/dashboard/salesdashboard',
        component: lazy(() => import('@/views/dashboard/SalesDashboard')),
        authority: [],
    },
    {
        key: 'calendar.holidaycalendar',
        path: '/calendar/holidaycalendar',
        component: lazy(() => import('@/views/calendar/HolidayCalendar')),
        authority: [],
    },
    {
        key: 'serviceMenu.permissionRequest',
        path: '/permissionrequest',
        component: lazy(() => import('@/views/self-service/OutpassRequest')),
        authority: [],
    },
    {
        key: 'serviceMenu.permissionRequestList',
        path: '/permissionrequest/list',
        component: lazy(
            () => import('@/views/self-service/ListOutpassRequest'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.permissionRequestView',
        path: '/permissionrequest/view',
        component: lazy(
            () => import('@/views/self-service/ViewOutpassRequest'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.teampermissionList',
        path: '/teampermission/list',
        component: lazy(() => import('@/views/self-service/ListTeamOutpass')),
        authority: [],
    },
    // {
    //     key: 'serviceMenu.teamOutpass',
    //     path: '/teamoutpass',
    //     component: lazy(() => import('@/views/self-service/TeamOutpass')),
    //     authority: [],
    // },

    {
        key: 'serviceMenu.',
        path: '/leaveapplication',
        component: lazy(() => import('@/views/self-service/LeaveApplication')),
        authority: [],
    },
    {
        key: 'serviceMenu.teampermissionView',
        path: '/teampermission/view',
        component: lazy(() => import('@/views/self-service/ViewTeamOutpass')),
        authority: [],
    },
    {
        key: 'serviceMenu.leaveApplication',
        path: '/leaveapplication',
        component: lazy(() => import('@/views/self-service/LeaveApplication')),
        authority: [],
    },
    {
        key: 'serviceMenu.leaveApplicationList',
        path: '/leaveapplication/list',
        component: lazy(
            () => import('@/views/self-service/ListLeaveApplication'),
        ) as any,
        authority: [],
    },
    {
        key: 'serviceMenu.editRequestList',
        path: '/editrequest/list',
        component: lazy(
            () => import('@/views/self-service/EditRequest/ListEditRequest'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.editRequestView',
        path: '/editrequest/view',
        component: lazy(
            () => import('@/views/self-service/EditRequest/ViewEditRequest'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.teamEditRequestList',
        path: '/teameditrequest/list',
        component: lazy(
            () =>
                import('@/views/self-service/EditRequest/TeamListEditRequest'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.teamEditRequestView',
        path: '/teameditrequest/view',
        component: lazy(
            () =>
                import('@/views/self-service/EditRequest/TeamViewEditRequest'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.employeeEditRequestList',
        path: '/employeeeditrequest/list',
        component: lazy(
            () =>
                import(
                    '@/views/self-service/EditRequest/EmployeeListEditRequest'
                ),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.employeeEditRequestView',
        path: '/employeeeditrequest/view',
        component: lazy(
            () =>
                import(
                    '@/views/self-service/EditRequest/EmployeeViewEditRequest'
                ),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.leaveApplicationView',
        path: '/leaveapplication/view',
        component: lazy(
            () => import('@/views/self-service/ViewLeaveApplication'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.teamleaveApplication',
        path: '/teamleaveapplication/list',
        component: lazy(
            () => import('@/views/self-service/ListTeamLeaveApplication'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.teamleaveApplicationView',
        path: '/teamleaveapplication/view',
        component: lazy(
            () => import('@/views/self-service/ViewTeamLeaveApplication'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.onDuty',
        path: '/onduty',
        component: lazy(() => import('@/views/self-service/OnDuty')),
        authority: [],
    },
    {
        key: 'serviceMenu.teamonDutyList',
        path: '/teamonduty/list',
        component: lazy(() => import('@/views/self-service/ListTeamOnDuty')),
        authority: [],
    },
    {
        key: 'serviceMenu.teamonDuty',
        path: '/teamonduty',
        component: lazy(() => import('@/views/self-service/TeamOnDuty')),
        authority: [],
    },
    {
        key: 'serviceMenu.teamonDutyView',
        path: '/teamonduty/view',
        component: lazy(() => import('@/views/self-service/ViewTeamOnDuty')),
        authority: [],
    },
    {
        key: 'serviceMenu.onDutyList',
        path: '/onduty/list',
        component: lazy(() => import('@/views/self-service/ListOnDuty')),
        authority: [],
    },
    {
        key: 'serviceMenu.onDutyView',
        path: '/onduty/view',
        component: lazy(() => import('@/views/self-service/ViewOnDuty')),
        authority: [],
    },
    {
        key: 'profilechangepasswordotp',
        path: '/profilechange-otp',
        component: lazy(() => import('@/views/self-service/ProfileChangeOtp')),
        authority: [],
    },
    {
        key: 'profilechangepassword',
        path: '/profilechange-password',
        component: lazy(
            () => import('@/views/self-service/ProfileChangePassword'),
        ),
        authority: [],
    },
    {
        key: 'userchangepasswordotp',
        path: '/userchange-otp',
        component: lazy(() => import('@/views/self-service/UserChangeOtp')),
        authority: [],
    },
    {
        key: 'userchangepassword',
        path: '/userchange-password',
        component: lazy(
            () => import('@/views/self-service/UserChangePassword'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.myBot',
        path: '/mybot',
        component: lazy(() => import('@/views/self-service/Chat/MyBot')),
        authority: [],
    },
    {
        key: 'serviceMenu.chat',
        path: '/chat',
        component: lazy(() => import('@/views/self-service/NewChat/Chat')),
        authority: [],
    },
    {
        key: 'serviceMenu.chat',
        path: '/demochat',
        component: lazy(() => import('@/views/self-service/DemoChat/Chat')),
        authority: [],
    },

    {
        key: 'serviceMenu.holidaySupport',
        path: '/holidaysupport',
        component: lazy(() => import('@/views/self-service/HolidaySupport')),
        authority: [],
    },
    {
        key: 'serviceMenu.holidaySupportList',
        path: '/holidaysupport/list',
        component: lazy(
            () => import('@/views/self-service/ListHolidaySupport'),
        ) as any,
        authority: [],
    },
    {
        key: 'serviceMenu.holidaySupportView',
        path: '/holidaysupport/view',
        component: lazy(
            () => import('@/views/self-service/ViewHolidaySupport'),
        ),
        authority: [],
    },

    {
        key: 'serviceMenu.compoffrequest',
        path: '/compoffrequest',
        component: lazy(() => import('@/views/self-service/CompOffRequest')),
        authority: [],
    },
    {
        key: 'serviceMenu.compoffrequestList',
        path: '/compoffrequest/list',
        component: lazy(
            () => import('@/views/self-service/ListCompOffRequest'),
        ) as any,
        authority: [],
    },
    {
        key: 'serviceMenu.compoffrequestView',
        path: '/compoffrequest/view',
        component: lazy(
            () => import('@/views/self-service/ViewCompOffRequest'),
        ),
        authority: [],
    },

    {
        key: 'teamCompoffRequestList',
        path: '/teamcompoffrequest/list',
        component: lazy(
            () => import('@/views/self-service/ListTeamCompOffRequest'),
        ) as any,
        authority: [],
    },
    {
        key: 'teamCompoffRequestView',
        path: '/teamcompoffrequest/view',
        component: lazy(
            () => import('@/views/self-service/ViewTeamCompOffRequest'),
        ),
        authority: [],
    },

    {
        key: 'teamHolidaySupportList',
        path: '/teamholidaysupport/list',
        component: lazy(
            () => import('@/views/self-service/ListTeamHolidaySupport'),
        ) as any,
        authority: [],
    },
    {
        key: 'teamHolidaySupportView',
        path: '/teamholidaysupport/view',
        component: lazy(
            () => import('@/views/self-service/ViewTeamHolidaySupport'),
        ),
        authority: [],
    },

    {
        key: 'attendanceRequestList',
        path: '/attendancerequest/list',
        component: lazy(
            () => import('@/views/self-service/ListAttendanceRequest'),
        ),
        authority: [],
    },
    {
        key: 'attendanceRequest',
        path: '/attendancerequest',
        component: lazy(() => import('@/views/self-service/AttendanceRequest')),
        authority: [],
    },
    {
        key: 'attendanceRequestView',
        path: '/attendancerequest/view',
        component: lazy(
            () => import('@/views/self-service/ViewAttendanceRequest'),
        ),
        authority: [],
    },
    {
        key: 'myAttendanceList',
        path: '/myattendance/list',
        component: lazy(() => import('@/views/self-service/ListMyAttendance')),
        authority: [],
    },
    // {
    //     key: 'myAttendanceAdd',
    //     path: '/myattendance',
    //     component: lazy(() => import('@/views/self-service/MyAttendance')),
    //     authority: [],
    // },
    {
        key: 'myAttendanceView',
        path: '/myattendance/view',
        component: lazy(() => import('@/views/self-service/ViewMyAttendance')),
        authority: [],
    },
    {
        key: 'teamAttendanceList',
        path: '/myteam/teamattendance/list',
        component: lazy(() => import('@/views/myteam/ListTeamAttendance')),
        authority: [],
    },
    {
        key: 'teamMembersList',
        path: '/myteam/members/list',
        component: lazy(() => import('@/views/myteam/ListTeamMembers')),
        authority: [],
    },
    {
        key: 'teamResignationList',
        path: '/myteam/resignation/request',
        component: lazy(() => import('@/views/myteam/ListTeamResignation')),
        authority: [],
    },
    {
        key: 'teamAttendanceView',
        path: '/myteam/teamattendance/view',
        component: lazy(() => import('@/views/myteam/ViewTeamAttendance')),
        authority: [],
    },
    {
        key: 'teamAttendanceRequestList',
        path: '/teamattendancerequest/list',
        component: lazy(
            () => import('@/views/self-service/ListTeamAttendanceRequest'),
        ),
        authority: [],
    },
    {
        key: 'teamAttendanceRequestView',
        path: '/teamattendancerequest/view',
        component: lazy(
            () => import('@/views/self-service/ViewTeamAttendanceRequest'),
        ),
        authority: [],
    },
    {
        key: 'profileMenu.techProfile',
        path: '/profile/techprofile',
        component: lazy(() => import('@/views/profile/TechProfile')),
        authority: [],
    },
    // {
    //     key: 'serviceMenu.manualAttendanceList',
    //     path: '/manualattendance/list',
    //     component: lazy(() => import('@/views/self-service/ListManualAttendance')),
    //     authority: [],
    // },
    {
        key: 'serviceMenu.manualAttendance',
        path: '/manualattendance',
        component: lazy(() => import('@/views/self-service/ManualAttendance')),
        authority: [],
    },
    {
        key: 'serviceMenu.manualAttendanceView',
        path: '/manualattendance/view',
        component: lazy(
            () => import('@/views/self-service/ViewManualAttendance'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.manualAttendanceEdit',
        path: '/manualattendance/edit',
        component: lazy(
            () => import('@/views/self-service/EditManualAttendance'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.salaryadvanceList',
        path: '/salaryadvance/list',
        component: lazy(() => import('@/views/self-service/ListSalaryAdvance')),
        authority: [],
    },
    {
        key: 'serviceMenu.salaryadvance',
        path: '/salaryadvance',
        component: lazy(
            () => import('@/views/self-service/SalaryAdvanceRequest'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.salaryadvanceView',
        path: '/salaryadvance/view',
        component: lazy(
            () => import('@/views/self-service/ViewSalaryAdvanceRequest'),
        ),
        authority: [],
    },
    {
        key: 'wfhApplicationList',
        path: '/wfhapplication/list',
        component: lazy(
            () => import('@/views/self-service/ListWfhApplication'),
        ),
        authority: [],
    },
    {
        key: 'wfhApplication',
        path: '/wfhapplication',
        component: lazy(() => import('@/views/self-service/WfhApplication')),
        authority: [],
    },
    {
        key: 'wfhApplicationView',
        path: '/wfhapplication/view',
        component: lazy(
            () => import('@/views/self-service/ViewWfhApplication'),
        ),
        authority: [],
    },
    {
        key: 'TeamwfhApplicationList',
        path: '/teamwfhapplication/list',
        component: lazy(
            () => import('@/views/self-service/ListTeamWfhApplication'),
        ),
        authority: [],
    },
    {
        key: 'TeamwfhApplicationView',
        path: '/teamwfhapplication/view',
        component: lazy(
            () => import('@/views/self-service/ViewTeamWfhApplication'),
        ),
        authority: [],
    },
    {
        key: 'MyclaimList',
        path: '/myclaim/list',
        component: lazy(() => import('@/views/self-service/ListMyClaim')),
        authority: [],
    },
    {
        key: 'Myclaim',
        path: '/myclaim',
        component: lazy(() => import('@/views/self-service/MyClaim')),
        authority: [],
    },
    {
        key: 'MyclaimView',
        path: '/myclaim/view',
        component: lazy(() => import('@/views/self-service/ViewMyClaim')),
        authority: [],
    },
    {
        key: 'teamclaimList',
        path: '/teamclaim/list',
        component: lazy(() => import('@/views/self-service/ListTeamClaim')),
        authority: [],
    },
    {
        key: 'teamclaimView',
        path: '/teamclaim/view',
        component: lazy(() => import('@/views/self-service/ViewTeamClaim')),
        authority: [],
    },
    {
        key: 'myWishes',
        path: '/mywishes',
        component: lazy(() => import('@/views/self-service/MyWishes')),
        authority: [],
    },
    {
        key: 'profileMenu.basicdetails',
        path: '/profile/basicdetails',
        component: lazy(() => import('@/views/profile/BasicDetailsView')),
        authority: [],
    },
    {
        key: 'profileMenu.basicdetails.edit',
        path: '/profile/basicdetails/edit',
        component: lazy(() => import('@/views/profile/BasicDetailsEdit')),
        authority: [],
    },
    {
        key: 'profileMenu.familydetails',
        path: '/profile/familydetails',
        component: lazy(() => import('@/views/profile/FamilyDetailsView')),
        authority: [],
    },
    {
        key: 'profileMenu.familydetails.edit',
        path: '/profile/familydetails/edit',
        component: lazy(() => import('@/views/profile/FamilyDetailsEdit')),
        authority: [],
    },
    {
        key: 'profileMenu.education',
        path: '/profile/education',
        component: lazy(() => import('@/views/profile/Education')),
        authority: [],
    },
    {
        key: 'profileMenu.employment',
        path: '/profile/employment',
        component: lazy(() => import('@/views/profile/Employment')),
        authority: [],
    },
    {
        key: 'profileMenu.passportdetails',
        path: '/profile/passportdetails',
        component: lazy(() => import('@/views/profile/PassportDetailsView')),
        authority: [],
    },
    {
        key: 'profileMenu.passportdetails.edit',
        path: '/profile/passportdetails/edit',
        component: lazy(() => import('@/views/profile/PassportDetailsEdit')),
        authority: [],
    },
    {
        key: 'profileMenu.bank',
        path: '/profile/bank',
        component: lazy(() => import('@/views/profile/BankDetailsView')),
        authority: [],
    },
    {
        key: 'profileMenu.bank.edit',
        path: '/profile/bank/edit',
        component: lazy(() => import('@/views/profile/BankDetailsEdit')),
        authority: [],
    },
    {
        // Backend menu item "Register Face" links here.
        key: 'profileMenu.regface',
        path: '/profile/reg_face',
        component: lazy(() => import('@/views/profile/FaceRegisterView')),
        authority: [],
    },
    {
        key: 'profileMenu.faceregister',
        path: '/profile/face-register',
        component: lazy(() => import('@/views/profile/FaceRegisterView')),
        authority: [],
    },
    {
        // Admin » Register Face: own page. Office and Employee are required;
        // status via /employeestatus, save via /adminsave or /adminupdate.
        key: 'admin.regface',
        path: '/admin/reg_face',
        component: lazy(() => import('@/views/admin/AdminRegFace')),
        authority: [],
    },
    {
        key: 'profileMenu.address',
        path: '/profile/address',
        component: lazy(() => import('@/views/profile/AddressView')),
        authority: [],
    },
    {
        key: 'profileMenu.address.edit',
        path: '/profile/address/edit',
        component: lazy(() => import('@/views/profile/AddressEdit')),
        authority: [],
    },
    {
        key: 'profileMenu.emergencyContact',
        path: '/profile/emergencycontact',
        component: lazy(() => import('@/views/profile/EmergencyContactView')),
        authority: [],
    },
    {
        key: 'profileMenu.emergencyContact.edit',
        path: '/profile/emergencycontact/edit',
        component: lazy(() => import('@/views/profile/EmergencyContactEdit')),
        authority: [],
    },
    {
        key: 'hradminMenu.manualAttendanceList',
        path: '/manualattendance/list',
        component: lazy(
            () => import('@/views/self-service/ListManualAttendance'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.employeePermissionList',
        path: '/emppermission/list',
        component: lazy(() => import('@/views/hradmin/ListEmployeePermission')),
        authority: [],
    },
    {
        key: 'hradminMenu.employeeLeaveList',
        path: '/empleave/list',
        component: lazy(
            () => import('@/views/hradmin/ListEmployeeLeaveApplication'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.employeeLeaveView',
        path: '/empleave/view',
        component: lazy(
            () => import('@/views/hradmin/ViewEmployeeLeaveApplication'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.employeeDutyList',
        path: '/empod/list',
        component: lazy(() => import('@/views/hradmin/ListEmployeeOnDuty')),
        authority: [],
    },
    {
        key: 'hradminMenu.employeeDutyView',
        path: '/empod/view',
        component: lazy(() => import('@/views/hradmin/ViewEmployeeOnDuty')),
        authority: [],
    },
    {
        key: 'hradminMenu.empApprovalDelegationList',
        path: '/empapprovaldelegation/list',
        component: lazy(() => import('@/views/hradmin/ListApprovalDelegation')),
        authority: [],
    },
    {
        key: 'hradminMenu.candidateApplicationList',
        path: '/candidateapplication/list',
        component: lazy(
            () => import('@/views/hradmin/ListCandidateApplication'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.candidateApplication',
        path: '/candidateapplication',
        component: lazy(() => import('@/views/hradmin/CandidateApplication')),
        authority: [],
    },
    {
        key: 'hradminMenu.candidateApplicationView',
        path: '/candidateapplication/view',
        component: lazy(
            () => import('@/views/hradmin/ViewCandidateApplication'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.candidateAssessmentList',
        path: '/candidateassessment/list',
        component: lazy(
            () => import('@/views/hradmin/ListCandidateAssessment'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.candidateAssessment',
        path: '/candidateassessment',
        component: lazy(() => import('@/views/hradmin/CandidateAssessment')),
        authority: [],
    },
    {
        key: 'hradminMenu.candidateAssessmentView',
        path: '/candidateassessment/view',
        component: lazy(
            () => import('@/views/hradmin/ViewCandidateAssessment'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.noticeBoardList',
        path: '/noticeboard/list',
        component: lazy(() => import('@/views/hradmin/ListNoticeBoard')),
        authority: [],
    },
    {
        key: 'hradminMenu.noticeBoard',
        path: '/noticeboard',
        component: lazy(() => import('@/views/hradmin/NoticeBoard')),
        authority: [],
    },
    {
        key: 'hradminMenu.noticeBoardView',
        path: '/noticeboard/view',
        component: lazy(() => import('@/views/hradmin/ViewNoticeBoard')),
        authority: [],
    },
    {
        key: 'hradminMenu.employeeDetails',
        path: '/employeedetails',
        component: lazy(() => import('@/views/hradmin/EmployeeDetails')),
        authority: [],
    },
    {
        key: 'hradminMenu.projectsList',
        path: '/projects/list',
        component: lazy(() => import('@/views/hradmin/ListProjects')),
        authority: [],
    },
    {
        key: 'hradminMenu.projects',
        path: '/projects',
        component: lazy(() => import('@/views/hradmin/Projects')),
        authority: [],
    },
    {
        key: 'hradminMenu.projectsView',
        path: '/projects/view',
        component: lazy(() => import('@/views/hradmin/ViewProjects')),
        authority: [],
    },
    {
        key: 'hradminMenu.employeeList',
        path: '/employee/list',
        component: lazy(() => import('@/views/hradmin/ListEmployee')),
        authority: [],
    },
    {
        key: 'hradminMenu.employeeMasterReport',
        path: '/employeemasterreport',
        component: lazy(() => import('@/views/hradmin/EmployeeMasterReport')),
        authority: [],
    },
    {
        key: 'hradminMenu.employee',
        path: '/employee',
        component: lazy(() => import('@/views/hradmin/Employee')),
        authority: [],
    },
    {
        key: 'hradminMenu.employeeView',
        path: '/employee/view',
        component: lazy(() => import('@/views/hradmin/ViewEmployee')),
        authority: [],
    },
    {
        key: 'hradminMenu.employeeList',
        path: '/employee/register-employee',
        component: lazy(() => import('@/views/hradmin/RegisterEmployee')),
        authority: [],
    },
    {
        key: 'hradminMenu.circularList',
        path: '/circular/list',
        component: lazy(() => import('@/views/hradmin/ListCircular')),
        authority: [],
    },
    {
        key: 'hradminMenu.circularAdd',
        path: '/circular',
        component: lazy(() => import('@/views/hradmin/Circular')),
        authority: [],
    },
    {
        key: 'hradminMenu.circularView',
        path: '/circular/view',
        component: lazy(() => import('@/views/hradmin/ViewCircular')),
        authority: [],
    },
    {
        key: 'hradminMenu.employeeMovementLogList',
        path: '/hradmin/empmovementlog',
        component: lazy(
            () => import('@/views/hradmin/ListEmployeeMovementLog'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.attendancebyqr',
        path: '/attendanceby-qr',
        component: lazy(() => import('@/views/hradmin/AttendanceByQR')),
        authority: [],
    },
    {
        key: 'hradminMenu.Listempleavebalance',
        path: '/hradmin/empleavebalance/list',
        component: lazy(() => import('@/views/hradmin/ListEmpLeaveBalance')),
        authority: [],
    },
    {
        key: 'hradminMenu.empleavebalance',
        path: '/hradmin/empleavebalance',
        component: lazy(() => import('@/views/hradmin/EmpLeaveBalance')),
        authority: [],
    },
    {
        key: 'hradminMenu.Viewempleavebalance',
        path: '/hradmin/empleavebalance/view',
        component: lazy(() => import('@/views/hradmin/ViewEmpLeaveBalance')),
        authority: [],
    },
    {
        key: 'hradminMenu.ListSalaryAdvanceDisbursement',
        path: '/hradmin/salaryadvancedisbursement/list',
        component: lazy(
            () => import('@/views/hradmin/ListSalaryAdvanceDisbursement'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.IssueSalaryAdvanceDisbursement',
        path: '/hradmin/salaryadvancedisbursement',
        component: lazy(
            () => import('@/views/hradmin/IssueSalaryAdvanceDisbursement'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.ViewSalaryAdvanceDisbursement',
        path: '/hradmin/salaryadvancedisbursement/view',
        component: lazy(
            () => import('@/views/hradmin/ViewSalaryAdvanceDisbursement'),
        ),
        authority: [],
    },
    {
        key: 'hradminMenu.EmployeeExitList',
        path: '/hradmin/empexit/list',
        component: lazy(() => import('@/views/hradmin/ListEmployeeExit')),
        authority: [],
    },
    {
        key: 'hradminMenu.EmployeeExitAdd',
        path: '/hradmin/empexit',
        component: lazy(() => import('@/views/hradmin/EmployeeExit')),
        authority: [],
    },
    {
        key: 'hradminMenu.EmployeeExitView',
        path: '/hradmin/empexit/view',
        component: lazy(() => import('@/views/hradmin/ViewEmployeeExit')),
        authority: [],
    },
    {
        key: 'hradminMenu.EmployeeExitFormalities',
        path: '/hradmin/empexit/formalities',
        component: lazy(() => import('@/views/hradmin/ExitFormalities')),
        authority: [],
    },
    {
        // Self-service menu entry ("Exit Register") points here
        key: 'hradminMenu.EmployeeExitFormalitiesSelf',
        path: '/empexit/formalities',
        component: lazy(() => import('@/views/hradmin/ExitFormalities')),
        authority: [],
    },
    {
        key: 'hradminMenu.EmployeeGateEntryList',
        path: '/hradmin/employeegateentry',
        component: lazy(() => import('@/views/hradmin/ListEmployeeGateEntry')),
        authority: [],
    },
    {
        key: 'hradminMenu.BiometricList',
        path: '/hradmin/biometricattendance',
        component: lazy(() => import('@/views/hradmin/Listbiometric')),
        authority: [],
    },
    {
        key: 'security.securityDashboard',
        path: '/security-dashboard',
        component: lazy(() => import('@/views/security/SecurityDashboard')),
        authority: [],
    },
    {
        key: 'security.employeeGatepass',
        path: '/employee-gatepass',
        component: lazy(() => import('@/views/security/EmployeeGateAccess')),
        authority: [],
    },
    {
        key: 'security.gateentry',
        path: '/gateentry',
        component: lazy(() => import('@/views/security/GateEntry')),
        authority: [],
    },
    {
        key: 'security.checkInOut',
        path: '/checkin',
        component: lazy(() => import('@/views/security/CheckInOut')),
        authority: [],
    },
    {
        key: 'security.permission',
        path: '/permission',
        component: lazy(() => import('@/views/security/Permission')),
        authority: [],
    },
    {
        key: 'security.breakReturn',
        path: '/break',
        component: lazy(() => import('@/views/security/BreakReturn')),
        authority: [],
    },
    {
        key: 'security.vehicleEntryExit',
        path: '/vehicleentryexit',
        component: lazy(() => import('@/views/security/VehicleEntryExit')),
        authority: [],
    },
    {
        key: 'security.vehicleEntryExitList',
        path: '/vehicleentryexit/list',
        component: lazy(() => import('@/views/security/ListVehicleEntryExit')),
        authority: [],
    },
    {
        key: 'security.vehicleEntryExitView',
        path: '/vehicleentryexit/view',
        component: lazy(() => import('@/views/security/ViewVehicleEntryExit')),
        authority: [],
    },
    {
        key: 'security.breakLunch',
        path: '/lunch-break',
        component: lazy(() => import('@/views/security/LunchBreak')),
        authority: [],
    },
    {
        key: 'security.Lunch',
        path: '/lunch',
        component: lazy(() => import('@/views/security/Lunch')),
        authority: [],
    },
    {
        key: 'security.visitormanagement',
        path: '/visitormanagement',
        component: lazy(() => import('@/views/security/VisitorManagementEntry')),
        authority: [],
    },
    {
        key: 'security.visitormanagementList',
        path: '/visitormanagement/list',
        component: lazy(() => import('@/views/security/ListVisitorManagement')),
        authority: [],
    },
    {
        key: 'security.visitormanagementView',
        path: '/visitormanagement/view',
        component: lazy(() => import('@/views/security/ViewVisitorManagement')),
        authority: [],
    },
    // {
    //     key: 'security.internship',
    //     path: '/internship',
    //     component: lazy(() => import('@/views/security/Internship')),
    //     authority: [],
    // },
    // {
    //     key: 'security.internshipList',
    //     path: '/internship/list',
    //     component: lazy(() => import('@/views/security/ListInternship')),
    //     authority: [],
    // },
    // {
    //     key: 'security.internshipView',
    //     path: '/internship/view',
    //     component: lazy(() => import('@/views/security/ViewInternship')),
    //     authority: [],
    // },
    {
        key: 'master.countryList',
        path: '/country/list',
        component: lazy(() => import('@/views/master/ListCountry')),
        authority: [],
    },
    {
        key: 'master.country',
        path: '/country',
        component: lazy(() => import('@/views/master/Country')),
        authority: [],
    },
    {
        key: 'master.countryView',
        path: '/country/view',
        component: lazy(() => import('@/views/master/ViewCountry')),
        authority: [],
    },
    {
        key: 'master.departmentList',
        path: '/department/list',
        component: lazy(() => import('@/views/master/ListDepartment')),
        authority: [],
    },
    {
        key: 'master.department',
        path: '/department',
        component: lazy(() => import('@/views/master/Department')),
        authority: [],
    },
    {
        key: 'master.departmentView',
        path: '/department/view',
        component: lazy(() => import('@/views/master/ViewDepartment')),
        authority: [],
    },
    {
        key: 'master.designationList',
        path: '/designation/list',
        component: lazy(() => import('@/views/master/ListDesignation')),
        authority: [],
    },
    {
        key: 'master.designation',
        path: '/designation',
        component: lazy(() => import('@/views/master/Designation')),
        authority: [],
    },
    {
        key: 'master.designationView',
        path: '/designation/view',
        component: lazy(() => import('@/views/master/ViewDesignation')),
        authority: [],
    },
    {
        key: 'master.clientList',
        path: '/client/list',
        component: lazy(() => import('@/views/master/ListClient')),
        authority: [],
    },
    {
        key: 'master.client',
        path: '/client',
        component: lazy(() => import('@/views/master/Client')),
        authority: [],
    },
    {
        key: 'master.clientView',
        path: '/client/view',
        component: lazy(() => import('@/views/master/ViewClient')),
        authority: [],
    },
    {
        key: 'master.courseList',
        path: '/course/list',
        component: lazy(() => import('@/views/master/ListCourse')),
        authority: [],
    },
    {
        key: 'master.course',
        path: '/course',
        component: lazy(() => import('@/views/master/Course')),
        authority: [],
    },
    {
        key: 'master.courseView',
        path: '/course/view',
        component: lazy(() => import('@/views/master/ViewCourse')),
        authority: [],
    },
    {
        key: 'master.educationList',
        path: '/education/list',
        component: lazy(() => import('@/views/master/ListEducation')),
        authority: [],
    },
    {
        key: 'master.education',
        path: '/mastereducation',
        component: lazy(() => import('@/views/master/Education')),
        authority: [],
    },
    {
        key: 'master.educationView',
        path: '/education/view',
        component: lazy(() => import('@/views/master/ViewEducation')),
        authority: [],
    },
    {
        key: 'master.jobtitleList',
        path: '/jobtitle/list',
        component: lazy(() => import('@/views/master/ListJobtitle')),
        authority: [],
    },
    {
        key: 'master.jobtitle',
        path: '/jobtitle',
        component: lazy(() => import('@/views/master/JobtitleMaster')),
        authority: [],
    },
    {
        key: 'master.jobtitleView',
        path: '/jobtitle/view',
        component: lazy(() => import('@/views/master/ViewJobtitle')),
        authority: [],
    },
    {
        key: 'master.bloodgroupList',
        path: '/bloodgroup/list',
        component: lazy(() => import('@/views/master/ListBloodgroup')),
        authority: [],
    },
    {
        key: 'master.bloodgroup',
        path: '/bloodgroup',
        component: lazy(() => import('@/views/master/BloodGroup')),
        authority: [],
    },
    {
        key: 'master.bloodgroupView',
        path: '/bloodgroup/view',
        component: lazy(() => import('@/views/master/ViewBloodgroup')),
        authority: [],
    },
    {
        key: 'master.genderList',
        path: '/gender/list',
        component: lazy(() => import('@/views/master/ListGender')),
        authority: [],
    },
    {
        key: 'master.gender',
        path: '/gender',
        component: lazy(() => import('@/views/master/Gender')),
        authority: [],
    },
    {
        key: 'master.genderView',
        path: '/gender/view',
        component: lazy(() => import('@/views/master/ViewGender')),
        authority: [],
    },
    {
        key: 'master.languageList',
        path: '/language/list',
        component: lazy(() => import('@/views/master/ListLanguage')),
        authority: [],
    },
    {
        key: 'master.language',
        path: '/language',
        component: lazy(() => import('@/views/master/Language')),
        authority: [],
    },
    {
        key: 'master.languageView',
        path: '/language/view',
        component: lazy(() => import('@/views/master/ViewLanguage')),
        authority: [],
    },
    {
        key: 'master.leavetypemasterList',
        path: '/leavetype/list',
        component: lazy(() => import('@/views/master/ListLeavetype')),
        authority: [],
    },
    {
        key: 'master.leavetypemaster',
        path: '/leavetype',
        component: lazy(() => import('@/views/master/LeavetypeMaster')),
        authority: [],
    },
    {
        key: 'master.leavetypemasterView',
        path: '/leavetype/view',
        component: lazy(() => import('@/views/master/ViewLeavetype')),
        authority: [],
    },

    {
        key: 'master.visacategoryList',
        path: '/visacategory/list',
        component: lazy(() => import('@/views/master/ListVisa')),
        authority: [],
    },
    {
        key: 'master.visacategory',
        path: '/visacategory',
        component: lazy(() => import('@/views/master/VisaCategory')),
        authority: [],
    },
    {
        key: 'master.visacategoryView',
        path: '/visacategory/view',
        component: lazy(() => import('@/views/master/ViewVisa')),
        authority: [],
    },
    {
        key: 'master.ratingList',
        path: '/rating/list',
        component: lazy(() => import('@/views/master/ListRating')),
        authority: [],
    },
    {
        key: 'master.rating',
        path: '/rating',
        component: lazy(() => import('@/views/master/RatingMaster')),
        authority: [],
    },
    {
        key: 'master.ratingView',
        path: '/rating/view',
        component: lazy(() => import('@/views/master/ViewRating')),
        authority: [],
    },
    {
        key: 'master.relationList',
        path: '/relation/list',
        component: lazy(() => import('@/views/master/ListRelation')),
        authority: [],
    },
    {
        key: 'master.relation',
        path: '/relation',
        component: lazy(() => import('@/views/master/RelationMaster')),
        authority: [],
    },
    {
        key: 'master.relationView',
        path: '/relation/view',
        component: lazy(() => import('@/views/master/ViewRelation')),
        authority: [],
    },
    {
        key: 'master.shiftList',
        path: '/shift/list',
        component: lazy(() => import('@/views/master/ListShift')),
        authority: [],
    },
    {
        key: 'master.shift',
        path: '/shift',
        component: lazy(() => import('@/views/master/Shift')),
        authority: [],
    },
    {
        key: 'master.shiftView',
        path: '/shift/view',
        component: lazy(() => import('@/views/master/ViewShift')),
        authority: [],
    },
    {
        key: 'master.universityList',
        path: '/university/list',
        component: lazy(() => import('@/views/master/ListUniversity')),
        authority: [],
    },
    {
        key: 'master.university',
        path: '/university',
        component: lazy(() => import('@/views/master/University')),
        authority: [],
    },
    {
        key: 'master.universityView',
        path: '/university/view',
        component: lazy(() => import('@/views/master/ViewUniversity')),
        authority: [],
    },
    {
        key: 'master.rolemasterList',
        path: '/rolemaster/list',
        component: lazy(() => import('@/views/master/ListRolemaster')),
        authority: [],
    },
    {
        key: 'master.rolemaster',
        path: '/rolemaster',
        component: lazy(() => import('@/views/master/RoleMaster')),
        authority: [],
    },
    {
        key: 'master.rolemasterView',
        path: '/rolemaster/view',
        component: lazy(() => import('@/views/master/ViewRolemaster')),
        authority: [],
    },
    {
        key: 'master.coursetypeList',
        path: '/coursetype/list',
        component: lazy(() => import('@/views/master/ListCoursetype')),
        authority: [],
    },
    {
        key: 'master.coursetype',
        path: '/coursetype',
        component: lazy(() => import('@/views/master/CoursetypeMaster')),
        authority: [],
    },
    {
        key: 'master.coursetypeView',
        path: '/coursetype/view',
        component: lazy(() => import('@/views/master/ViewCoursetype')),
        authority: [],
    },

    {
        key: 'master.specializationList',
        path: '/specialization/list',
        component: lazy(() => import('@/views/master/ListSpecialization')),
        authority: [],
    },
    {
        key: 'master.specialization',
        path: '/specialization',
        component: lazy(() => import('@/views/master/SpecializationMaster')),
        authority: [],
    },
    {
        key: 'master.specializationView',
        path: '/specialization/view',
        component: lazy(() => import('@/views/master/ViewSpecialization')),
        authority: [],
    },

    {
        key: 'master.employmenttypeList',
        path: '/employmenttype/list',
        component: lazy(() => import('@/views/master/ListEmploymenttype')),
        authority: [],
    },
    {
        key: 'master.employmenttype',
        path: '/employmenttype',
        component: lazy(() => import('@/views/master/EmploymenttypeMaster')),
        authority: [],
    },
    {
        key: 'master.employmenttypeView',
        path: '/employmenttype/view',
        component: lazy(() => import('@/views/master/ViewEmploymenttype')),
        authority: [],
    },

    {
        key: 'master.empcategoryList',
        path: '/empcategory/list',
        component: lazy(() => import('@/views/master/ListEmpcategory')),
        authority: [],
    },
    {
        key: 'master.empcategory',
        path: '/empcategory',
        component: lazy(() => import('@/views/master/EmpcategoryMaster')),
        authority: [],
    },
    {
        key: 'master.empcategoryView',
        path: '/empcategory/view',
        component: lazy(() => import('@/views/master/ViewEmpcategory')),
        authority: [],
    },

    {
        key: 'master.technologyList',
        path: '/technologymaster/list',
        component: lazy(() => import('@/views/master/ListTechnology')),
        authority: [],
    },
    {
        key: 'master.technology',
        path: '/technology',
        component: lazy(() => import('@/views/master/TechnologyMaster')),
        authority: [],
    },
    {
        key: 'master.technologyView',
        path: '/technology/view',
        component: lazy(() => import('@/views/master/ViewTechnology')),
        authority: [],
    },

    {
        key: 'master.workfromhomereasonList',
        path: '/workfromhomereason/list',
        component: lazy(() => import('@/views/master/ListWorkFromHomeReason')),
        authority: [],
    },
    {
        key: 'master.workfromhomereason',
        path: '/workfromhomereason',
        component: lazy(() => import('@/views/master/WorkFromHomeReason')),
        authority: [],
    },
    {
        key: 'master.workfromhomereasonView',
        path: '/workfromhomereason/view',
        component: lazy(() => import('@/views/master/ViewWorkFromHomeReason')),
        authority: [],
    },

    {
        key: 'master.projectList',
        path: '/project/list',
        component: lazy(() => import('@/views/master/ListProjectMaster')),
        authority: [],
    },
    {
        key: 'master.project',
        path: '/project',
        component: lazy(() => import('@/views/master/ProjectMaster')),
        authority: [],
    },
    {
        key: 'master.projectView',
        path: '/project/view',
        component: lazy(() => import('@/views/master/ViewProjectMaster')),
        authority: [],
    },

    {
        key: 'master.technologycategoryList',
        path: '/technologycategory/list',
        component: lazy(() => import('@/views/master/ListTechnologyCategory')),
        authority: [],
    },
    {
        key: 'master.technologycategory',
        path: '/technologycategory',
        component: lazy(() => import('@/views/master/TechnologyCategory')),
        authority: [],
    },
    {
        key: 'master.technologycategoryView',
        path: '/technologycategory/view',
        component: lazy(() => import('@/views/master/ViewTechnologyCategory')),
        authority: [],
    },

    {
        key: 'master.projecttypeList',
        path: '/projecttype/list',
        component: lazy(() => import('@/views/master/ListProjectType')),
        authority: [],
    },
    {
        key: 'master.projecttype',
        path: '/projecttype',
        component: lazy(() => import('@/views/master/ProjectType')),
        authority: [],
    },
    {
        key: 'master.projecttypeView',
        path: '/projecttype/view',
        component: lazy(() => import('@/views/master/ViewProjectType')),
        authority: [],
    },

    {
        key: 'master.areamasterList',
        path: 'areamaster/list',
        component: lazy(() => import('@/views/master/ListAreaMaster')),
        authority: [],
    },
    {
        key: 'master.areamaster',
        path: '/areamaster',
        component: lazy(() => import('@/views/master/AreaMaster')),
        authority: [],
    },
    {
        key: 'master.areamasterView',
        path: '/areamaster/view',
        component: lazy(() => import('@/views/master/ViewAreaMaster')),
        authority: [],
    },

    {
        key: 'master.statemasterList',
        path: 'statemaster/list',
        component: lazy(() => import('@/views/master/ListStateMaster')),
        authority: [],
    },
    {
        key: 'master.statemaster',
        path: '/statemaster',
        component: lazy(() => import('@/views/master/StateMaster')),
        authority: [],
    },
    {
        key: 'master.statemasterView',
        path: '/statemaster/view',
        component: lazy(() => import('@/views/master/ViewStateMaster')),
        authority: [],
    },

    {
        key: 'master.citymasterList',
        path: 'citymaster/list',
        component: lazy(() => import('@/views/master/ListCityMaster')),
        authority: [],
    },
    {
        key: 'master.citymaster',
        path: '/citymaster',
        component: lazy(() => import('@/views/master/CityMaster')),
        authority: [],
    },
    {
        key: 'master.citymasterView',
        path: '/citymaster/view',
        component: lazy(() => import('@/views/master/ViewCityMaster')),
        authority: [],
    },

    {
        key: 'master.districtmasterList',
        path: 'districtmaster/list',
        component: lazy(() => import('@/views/master/ListDistrictMaster')),
        authority: [],
    },
    {
        key: 'master.districtmaster',
        path: '/districtmaster',
        component: lazy(() => import('@/views/master/DistrictMaster')),
        authority: [],
    },
    {
        key: 'master.districtmasterView',
        path: '/districtmaster/view',
        component: lazy(() => import('@/views/master/ViewDistrictMaster')),
        authority: [],
    },

    {
        key: 'master.attendancetypemasterList',
        path: 'attendancetypemaster/list',
        component: lazy(
            () => import('@/views/master/ListAttendanceTypeMaster'),
        ),
        authority: [],
    },
    {
        key: 'master.attendancetypemaster',
        path: '/attendancetypemaster',
        component: lazy(() => import('@/views/master/AttendanceTypeMaster')),
        authority: [],
    },
    {
        key: 'master.attendancetypemasterView',
        path: '/attendancetypemaster/view',
        component: lazy(
            () => import('@/views/master/ViewAttendanceTypeMaster'),
        ),
        authority: [],
    },

    {
        key: 'master.holidaymasterList',
        path: 'holidaymaster/list',
        component: lazy(() => import('@/views/master/ListHolidayMaster')),
        authority: [],
    },
    {
        key: 'master.holidaymaster',
        path: '/holidaymaster',
        component: lazy(() => import('@/views/master/HolidayMaster')),
        authority: [],
    },
    {
        key: 'master.holidaymasterView',
        path: '/holidaymaster/view',
        component: lazy(() => import('@/views/master/ViewHolidayMaster')),
        authority: [],
    },

    {
        key: 'master.addressmasterList',
        path: 'addressmaster/list',
        component: lazy(() => import('@/views/master/ListAddressMaster')),
        authority: [],
    },
    {
        key: 'master.addressmaster',
        path: '/addressmaster',
        component: lazy(() => import('@/views/master/AddressMaster')),
        authority: [],
    },
    {
        key: 'master.addressmasterView',
        path: '/addressmaster/view',
        component: lazy(() => import('@/views/master/ViewAddressMaster')),
        authority: [],
    },
    {
        key: 'master.vehicletypeList',
        path: 'vehicletype/list',
        component: lazy(() => import('@/views/master/ListVehicleType')),
        authority: [],
    },
    {
        key: 'master.vehicletype',
        path: '/vehicletype',
        component: lazy(() => import('@/views/master/VehicleType')),
        authority: [],
    },
    {
        key: 'master.vehicletypeView',
        path: '/vehicletype/view',
        component: lazy(() => import('@/views/master/ViewVehicleType')),
        authority: [],
    },

    {
        key: 'master.visitortypeList',
        path: 'visitortype/list',
        component: lazy(() => import('@/views/master/ListVisitorType')),
        authority: [],
    },
    {
        key: 'master.visitortype',
        path: '/visitortype',
        component: lazy(() => import('@/views/master/VisitorType')),
        authority: [],
    },
    {
        key: 'master.visitortypeView',
        path: '/visitortype/view',
        component: lazy(() => import('@/views/master/ViewVisitorType')),
        authority: [],
    },
    {
        key: 'master.visitingpurposeList',
        path: 'visitingpurpose/list',
        component: lazy(() => import('@/views/master/ListVisitingPurpose')),
        authority: [],
    },
    {
        key: 'master.visitingpurpose',
        path: '/visitingpurpose',
        component: lazy(() => import('@/views/master/VisitingPurpose')),
        authority: [],
    },
    {
        key: 'master.visitingpurposeView',
        path: '/visitingpurpose/view',
        component: lazy(() => import('@/views/master/ViewVisitingPurpose')),
        authority: [],
    },

    {
        key: 'master.organizationbranchList',
        path: '/organizationbranch/list',
        component: lazy(() => import('@/views/master/ListOrganizationbranch')),
        authority: [],
    },
    {
        key: 'master.organizationbranch',
        path: '/organizationbranch',
        component: lazy(() => import('@/views/master/Organizationbranch')),
        authority: [],
    },
    {
        key: 'master.organizationbranchView',
        path: '/organizationbranch/view',
        component: lazy(() => import('@/views/master/ViewOrganizationbranch')),
        authority: [],
    },
    {
        key: 'master.shiftReccurenceList',
        path: '/shiftrecurrencepattern/list',
        component: lazy(() => import('@/views/master/ListShiftRecurrence')),
        authority: [],
    },
    {
        key: 'master.shiftReccurenceAdd',
        path: '/shiftrecurrencepattern',
        component: lazy(() => import('@/views/master/ShiftRecurrence')),
        authority: [],
    },
    {
        key: 'master.shiftReccurenceView',
        path: '/shiftrecurrencepattern/view',
        component: lazy(() => import('@/views/master/ViewShiftRecurrence')),
        authority: [],
    },

    {
        key: 'master.outpassreasonList',
        path: '/outpassreason/list',
        component: lazy(() => import('@/views/master/ListOutPassReason')),
        authority: [],
    },
    {
        key: 'master.outpassreason',
        path: '/outpassreason',
        component: lazy(() => import('@/views/master/OutPassReason')),
        authority: [],
    },
    {
        key: 'master.outpassreasonView',
        path: '/outpassreason/view',
        component: lazy(() => import('@/views/master/ViewOutPassReason')),
        authority: [],
    },

    {
        key: 'master.organizationcategoryList',
        path: '/organizationcategory/list',
        component: lazy(
            () => import('@/views/master/ListOrganizationCategory'),
        ),
        authority: [],
    },
    {
        key: 'master.organizationcategory',
        path: '/organizationcategory',
        component: lazy(() => import('@/views/master/OrganizationCategory')),
        authority: [],
    },
    {
        key: 'master.organizationcategoryView',
        path: '/organizationcategory/view',
        component: lazy(
            () => import('@/views/master/ViewOrganizationCategory'),
        ),
        authority: [],
    },

    {
        key: 'master.transportmodeList',
        path: '/transportmode/list',
        component: lazy(() => import('@/views/master/ListTransportMode')),
        authority: [],
    },
    {
        key: 'master.transportmode',
        path: '/transportmode',
        component: lazy(() => import('@/views/master/TransportMode')),
        authority: [],
    },
    {
        key: 'master.transportmodeView',
        path: '/transportmode/view',
        component: lazy(() => import('@/views/master/ViewTransportMode')),
        authority: [],
    },
    {
        key: 'master.industrialtypeList',
        path: '/industrialtype/list',
        component: lazy(() => import('@/views/master/ListIndustrialType')),
        authority: [],
    },
    {
        key: 'master.industrialtype',
        path: '/industrialtype',
        component: lazy(() => import('@/views/master/IndustrialType')),
        authority: [],
    },
    {
        key: 'master.industrialtypeView',
        path: '/industrialtype/view',
        component: lazy(() => import('@/views/master/ViewIndustrialType')),
        authority: [],
    },

    {
        key: 'master.timezonemasterList',
        path: '/timezonemaster/list',
        component: lazy(() => import('@/views/master/ListTimeZoneMaster')),
        authority: [],
    },
    {
        key: 'master.timezonemaster',
        path: '/timezonemaster',
        component: lazy(() => import('@/views/master/TimeZoneMaster')),
        authority: [],
    },
    {
        key: 'master.timezonemasterView',
        path: '/timezonemaster/view',
        component: lazy(() => import('@/views/master/ViewTimeZoneMaster')),
        authority: [],
    },

    {
        key: 'master.expensecategoriesList',
        path: '/expensecategories/list',
        component: lazy(() => import('@/views/master/ListExpenseCategories')),
        authority: [],
    },
    {
        key: 'master.expensecategories',
        path: '/expensecategories',
        component: lazy(() => import('@/views/master/ExpenseCategories')),
        authority: [],
    },
    {
        key: 'master.expensecategoriesView',
        path: '/expensecategories/view',
        component: lazy(() => import('@/views/master/ViewExpenseCategories')),
        authority: [],
    },

    {
        key: 'master.currencymasterList',
        path: '/currencymaster/list',
        component: lazy(() => import('@/views/master/ListCurrencyMaster')),
        authority: [],
    },
    {
        key: 'master.currencymaster',
        path: '/currencymaster',
        component: lazy(() => import('@/views/master/CurrencyMaster')),
        authority: [],
    },
    {
        key: 'master.claimTypeList',
        path: '/claimtype/list',
        component: lazy(() => import('@/views/master/ListClaimType')),
        authority: [],
    },
    {
        key: 'master.socialplatformList',
        path: '/socialplatform/list',
        component: lazy(() => import('@/views/master/ListSocialPlatform')),
        authority: [],
    },
    {
        key: 'master.socialplatform',
        path: '/socialplatform',
        component: lazy(() => import('@/views/master/SocialPlatform')),
        authority: [],
    },
    {
        key: 'master.socialplatformView',
        path: '/socialplatform/view',
        component: lazy(() => import('@/views/master/ViewSocialPlatform')),
        authority: [],
    },
    {
        key: 'master.claimTypeAdd',
        path: '/claimtype',
        component: lazy(() => import('@/views/master/ClaimType')),
        authority: [],
    },
    {
        key: 'master.claimTypeView',
        path: '/claimtype/view',
        component: lazy(() => import('@/views/master/ViewClaimType')),
        authority: [],
    },
    {
        key: 'master.costCentersList',
        path: '/costcenters/list',
        component: lazy(() => import('@/views/master/ListCostCenters')),
        authority: [],
    },
    {
        key: 'master.costCentersList',
        path: '/costcenters',
        component: lazy(() => import('@/views/master/CostCenters')),
        authority: [],
    },
    {
        key: 'master.costCentersView',
        path: '/costcenters/view',
        component: lazy(() => import('@/views/master/ViewCostCenters')),
        authority: [],
    },
    {
        key: 'master.currencymasterView',
        path: '/currencymaster/view',
        component: lazy(() => import('@/views/master/ViewCurrencyMaster')),
        authority: [],
    },
    {
        key: 'master.orgWorkCalendarList',
        path: '/orgworkcalendar/list',
        component: lazy(() => import('@/views/master/ListOrgWorkCalendar')),
        authority: [],
    },
    {
        key: 'master.orgWorkCalendarAdd',
        path: '/orgworkcalendar',
        component: lazy(() => import('@/views/master/OrgWorkCalendar')),
        authority: [],
    },
    {
        key: 'master.orgWorkCalendarView',
        path: '/orgworkcalendar/view',
        component: lazy(() => import('@/views/master/ViewOrgWorkCalendar')),
        authority: [],
    },
    {
        key: 'master.businessDomainList',
        path: '/businessdomain/list',
        component: lazy(() => import('@/views/master/ListBusinessDomain')),
        authority: [],
    },
    {
        key: 'master.businessDomainAdd',
        path: '/businessdomain',
        component: lazy(() => import('@/views/master/BusinessDomain')),
        authority: [],
    },
    {
        key: 'master.businessDomainView',
        path: '/businessdomain/view',
        component: lazy(() => import('@/views/master/ViewBusinessDomain')),
        authority: [],
    },

    {
        key: 'master.empMovementypeList',
        path: '/empmovementtype/list',
        component: lazy(() => import('@/views/master/ListBreakTypeMaster')),
        authority: [],
    },
    {
        key: 'master.empMovementType',
        path: '/empmovementtype',
        component: lazy(() => import('@/views/master/BreakTypeMaster')),
        authority: [],
    },
    {
        key: 'master.empMovementTypeView',
        path: '/empmovementtype/view',
        component: lazy(() => import('@/views/master/ViewBreakTypeMaster')),
        authority: [],
    },

    {
        key: 'master.apptypeList',
        path: '/apptype/list',
        component: lazy(() => import('@/views/master/ListAppType')),
        authority: [],
    },
    {
        key: 'master.apptype',
        path: '/apptype',
        component: lazy(() => import('@/views/master/AppType')),
        authority: [],
    },
    {
        key: 'master.apptypeView',
        path: '/apptype/view',
        component: lazy(() => import('@/views/master/ViewAppType')),
        authority: [],
    },

    {
        key: 'master.projectmethodologyList',
        path: '/projectmethodology/list',
        component: lazy(() => import('@/views/master/ListProjectMethodology')),
        authority: [],
    },
    {
        key: 'master.projectmethodology',
        path: '/projectmethodology',
        component: lazy(() => import('@/views/master/ProjectMethodology')),
        authority: [],
    },
    {
        key: 'master.projectmethodologyView',
        path: '/projectmethodology/view',
        component: lazy(() => import('@/views/master/ViewProjectMethodology')),
        authority: [],
    },

    {
        key: 'master.originofbugList',
        path: '/originofbug/list',
        component: lazy(() => import('@/views/master/ListOriginOfBugMaster')),
        authority: [],
    },
    {
        key: 'master.originofbug',
        path: '/originofbug',
        component: lazy(() => import('@/views/master/OriginOfBug')),
        authority: [],
    },
    {
        key: 'master.originofbugView',
        path: '/originofbug/view',
        component: lazy(() => import('@/views/master/ViewOriginOfBugMaster')),
        authority: [],
    },

    {
        key: 'master.causeofeffectList',
        path: '/causeofeffect/list',
        component: lazy(() => import('@/views/master/ListCauseOfEffectMaster')),
        authority: [],
    },
    {
        key: 'master.causeofeffect',
        path: '/causeofeffect',
        component: lazy(() => import('@/views/master/CauseOfEffect')),
        authority: [],
    },
    {
        key: 'master.causeofeffectView',
        path: '/causeofeffect/view',
        component: lazy(() => import('@/views/master/ViewCauseOfEffectMaster')),
        authority: [],
    },

    {
        key: 'master.defecttypeList',
        path: '/defecttype/list',
        component: lazy(() => import('@/views/master/ListDefectTypeMaster')),
        authority: [],
    },
    {
        key: 'master.defecttype',
        path: '/defecttype',
        component: lazy(() => import('@/views/master/DefectType')),
        authority: [],
    },
    {
        key: 'master.defecttypeView',
        path: '/defecttype/view',
        component: lazy(() => import('@/views/master/ViewDefectTypeMaster')),
        authority: [],
    },

    {
        key: 'master.sprintstatusList',
        path: '/sprintstatus/list',
        component: lazy(() => import('@/views/master/ListSprintStatusMaster')),
        authority: [],
    },
    {
        key: 'master.sprintstatus',
        path: '/sprintstatus',
        component: lazy(() => import('@/views/master/SprintStatus')),
        authority: [],
    },
    {
        key: 'master.sprintstatusView',
        path: '/sprintstatus/view',
        component: lazy(() => import('@/views/master/ViewSprintStatusMaster')),
        authority: [],
    },

    {
        key: 'master.worktypeList',
        path: '/worktype/list',
        component: lazy(() => import('@/views/master/ListWorkTypeMaster')),
        authority: [],
    },
    {
        key: 'master.worktype',
        path: '/worktype',
        component: lazy(() => import('@/views/master/WorkTypeMaster')),
        authority: [],
    },
    {
        key: 'master.worktypeView',
        path: '/worktype/view',
        component: lazy(() => import('@/views/master/ViewWorkTypeMaster')),
        authority: [],
    },
    {
        key: 'master.countryView',
        path: '/country/view',
        component: lazy(() => import('@/views/master/ViewCountry')),
        authority: [],
    },

    {
        key: 'master.complexityAndStoryPointsList',
        path: '/complexityandstorypoints/list',
        component: lazy(
            () => import('@/views/master/ListComplexityAndStoryPoint'),
        ),
        authority: [],
    },
    {
        key: 'master.complexityAndStoryPoints',
        path: '/complexityandstorypoints',
        component: lazy(() => import('@/views/master/ComplexityAndStoryPoint')),
        authority: [],
    },
    {
        key: 'master.complexityAndStoryPointsView',
        path: '/complexityandstorypoints/view',
        component: lazy(
            () => import('@/views/master/ViewComplexityAndStoryPoint'),
        ),
        authority: [],
    },

    {
        key: 'master.componentList',
        path: '/component/list',
        component: lazy(() => import('@/views/master/ListComponent')),
        authority: [],
    },
    {
        key: 'master.component',
        path: '/component',
        component: lazy(() => import('@/views/master/Component')),
        authority: [],
    },
    {
        key: 'master.componentView',
        path: '/component/view',
        component: lazy(() => import('@/views/master/ViewComponent')),
        authority: [],
    },

    {
        key: 'master.severityofDefectList',
        path: '/severityofdefect/list',
        component: lazy(() => import('@/views/master/ListSeverityOfDefect')),
        authority: [],
    },
    {
        key: 'master.severityofDefect',
        path: '/severityofdefect',
        component: lazy(() => import('@/views/master/SeverityOfDefect')),
        authority: [],
    },
    {
        key: 'master.severityofDefectView',
        path: '/severityofdefect/view',
        component: lazy(() => import('@/views/master/ViewSeverityOfDefect')),
        authority: [],
    },

    {
        key: 'master.defectEnvironmentList',
        path: '/defectenvironment/list',
        component: lazy(() => import('@/views/master/ListDefectEnvironment')),
        authority: [],
    },
    {
        key: 'master.defectEnvironment',
        path: '/defectenvironment',
        component: lazy(() => import('@/views/master/DefectEnvironment')),
        authority: [],
    },
    {
        key: 'master.defectEnvironmentView',
        path: '/defectenvironment/view',
        component: lazy(() => import('@/views/master/ViewDefectEnvironment')),
        authority: [],
    },

    {
        key: 'Project Task.project',
        path: '/project/tasklist',
        component: lazy(
            () => import('@/views/projectmanagement/ListProjectTask'),
        ),
        authority: [],
    },
    {
        key: 'addProjectTask.projectAdd',
        path: '/addprojecttask',
        component: lazy(() => import('@/views/projectmanagement/ProjectTask')),
        authority: [],
    },
    {
        key: 'editProjectTask.projectedit',
        path: '/editprojecttask',
        component: lazy(() => import('@/views/projectmanagement/EditTask')),
        authority: [],
    },
    {
        key: 'fileUpload',
        path: '/fileupload',
        component: lazy(() => import('@/views/projectmanagement/FileUpload')),
        authority: [],
    },
    {
        key: 'ProjectTask.projectView',
        path: '/projecttask/view',
        component: lazy(
            () => import('@/views/projectmanagement/ViewProjectTask'),
        ),
        authority: [],
    },
    {
        key: 'Team Task.project',
        path: '/project/teamtasklist',
        component: lazy(() => import('@/views/projectmanagement/ListTeamTask')),
        authority: [],
    },
    {
        key: 'Team Task.projectAdd',
        path: '/addteamtask',
        component: lazy(() => import('@/views/projectmanagement/TeamTask')),
        authority: [],
    },
    {
        key: 'Team Task.projectView',
        path: '/teamtask/view',
        component: lazy(() => import('@/views/projectmanagement/ViewTeamTask')),
        authority: [],
    },
    {
        key: 'Team Task.projectView',
        path: '/teamtask/edit',
        component: lazy(() => import('@/views/projectmanagement/TeamTask')),
        authority: [],
    },
    {
        key: 'My Task.project',
        path: '/project/mytasklist',
        component: lazy(() => import('@/views/projectmanagement/ListMyTask')),
        authority: [],
    },
    {
        key: 'My Task.projectAdd',
        path: '/project/addmytask',
        component: lazy(() => import('@/views/projectmanagement/MyTask')),
        authority: [],
    },
    {
        key: 'My Task.projectView',
        path: '/project/mytask/view',
        component: lazy(() => import('@/views/projectmanagement/ViewMyTask')),
        authority: [],
    },
    {
        key: 'weeklysubmit',
        path: '/project/tasksubmission',
        component: lazy(() => import('@/views/projectmanagement/WeeklySubmit')),
        authority: [],
    },

    {
        key: 'weeklysubmitView',
        path: '/project/tasksubmission/view',
        component: lazy(
            () => import('@/views/projectmanagement/ViewTaskSubmission'),
        ),
        authority: [],
    },
    {
        key: 'teamworklog',
        path: '/project/teamworklog',
        component: lazy(
            () => import('@/views/projectmanagement/ListTeamWorkLog'),
        ),
        authority: [],
    },
    {
        key: 'teamworklogView',
        path: '/project/teamworklog/view',
        component: lazy(
            () => import('@/views/projectmanagement/ViewTeamWorkLog'),
        ),
        authority: [],
    },
    {
        key: 'taskworklogView',
        path: '/project/taskworklog/view',
        component: lazy(
            () => import('@/views/projectmanagement/viewtaskworklog'),
        ),
        authority: [],
    },
    {
        key: 'projectmodule',
        path: '/project/projectmodulelist',
        component: lazy(
            () => import('@/views/projectmanagement/ListProjectModule'),
        ),
        authority: [],
    },
    {
        key: 'projectmodule',
        path: '/project/projectmodule',
        component: lazy(
            () => import('@/views/projectmanagement/AddProjectModule'),
        ),
        authority: [],
    },
    {
        key: 'projectmodule',
        path: '/project/projectmodule/view',
        component: lazy(
            () => import('@/views/projectmanagement/ViewProjectModule'),
        ),
        authority: [],
    },
    {
        key: 'projectDashboard',
        path: '/project/projectdashboard',
        component: lazy(
            () => import('@/views/projectmanagement/ProjectDashboard'),
        ),
        authority: [],
    },
    {
        key: 'projectDashboardv2',
        path: '/project/projectdashboardv2',
        component: lazy(
            () => import('@/views/projectmanagement/ProjectDashboardv2'),
        ),
        authority: [],
    },
    {
        key: 'backlog',
        path: '/project/backlog',
        component: lazy(
            () => import('@/views/projectmanagement/backlog/BacklogMain'),
        ),
        authority: [],
    },
    {
        key: 'projectManagementMenu.scrumMeeting',
        path: '/project/scrummeeting',
        component: lazy(
            () => import('@/views/projectmanagement/ListScrumMeeting'),
        ),
        authority: [],
    },
    {
        key: 'projectManagementMenu.employeePerformance',
        path: '/project/employee-performance',
        component: lazy(
            () => import('@/views/projectmanagement/EmployeePerformance'),
        ),
        authority: [],
    },
    // {
    //     key: 'backlog',
    //     path: '/project/backlogv1',
    //     component: lazy(() => import('@/views/projectmanagement/Backlogv1')),
    //     authority: [],
    // },
    {
        key: 'phoneSpecificationList',
        path: '/phonespecification/list',
        component: lazy(
            () => import('@/views/phonespecification/ListPhoneSpecification'),
        ),
        authority: [],
    },
    {
        key: 'phoneSpecification',
        path: '/phonespecification',
        component: lazy(
            () => import('@/views/phonespecification/PhoneSpecification'),
        ),
        authority: [],
    },
    {
        key: 'phoneSpecificationView',
        path: '/phonespecification/view',
        component: lazy(
            () => import('@/views/phonespecification/ViewPhoneSpecification'),
        ),
        authority: [],
    },
    {
        key: 'tealunchbreakList',
        path: '/tealunchbreak/list',
        component: lazy(
            () => import('@/views/tealunchbreak/ListTeaLunchbreak'),
        ),
        authority: [],
    },
    {
        key: 'tealunchbreakAdd',
        path: '/tealunchbreak',
        component: lazy(() => import('@/views/tealunchbreak/TeaLunchbreak')),
        authority: [],
    },
    {
        key: 'empmovementlogAdd',
        path: '/hradmin/empmovementlog/add',
        component: lazy(() => import('@/views/hradmin/EmployeeMovementLog')),
        authority: [],
    },
    {
        key: 'empmovementlogView',
        path: '/empmovementlog/view',
        component: lazy(() => import('@/views/hradmin/ViewMovementLog')),
        authority: [],
    },
    {
        key: 'tealunchbreakView',
        path: '/tealunchbreak/view',
        component: lazy(
            () => import('@/views/tealunchbreak/ViewTeaLunchbreak'),
        ),
        authority: [],
    },

    // {
    //     key: 'projectManagementMenu.projectTaskList',
    //     path: '/project/tasklist',
    //     component: lazy(() => import('@/views/projectmanagement/ListProjectTask')),
    //     authority: [],
    // },
    {
        key: 'changePassword',
        path: `/change-password`,
        component: lazy(() => import('@/views/ChangePassword')),
        authority: [],
    },
    {
        key: 'master.taskStatus',
        path: `/taskstatusmaster/list`,
        component: lazy(() => import('@/views/master/ListTaskStatusMaster')),
        authority: [],
    },
    {
        key: 'master.taskStatus',
        path: `/taskstatusmaster/add`,
        component: lazy(() => import('@/views/master/AddTaskStatusMaster')),
        authority: [],
    },
    {
        key: 'master.taskStatus',
        path: `/taskstatusmaster/edit`,
        component: lazy(() => import('@/views/master/AddTaskStatusMaster')),
        authority: [],
    },
    {
        key: 'master.taskStatus',
        path: `/taskstatusmaster/view`,
        component: lazy(() => import('@/views/master/VIewTaskStatusMaster')),
        authority: [],
    },
    {
        key: 'master.taskPriority',
        path: `/taskprioritymaster/list`,
        component: lazy(() => import('@/views/master/ListTaskPriorityMaster')),
        authority: [],
    },
    {
        key: 'master.taskPriority',
        path: `/taskprioritymaster/add`,
        component: lazy(() => import('@/views/master/AddTaskPriorityMaster')),
        authority: [],
    },
    {
        key: 'master.taskPriority',
        path: `/taskprioritymaster/edit`,
        component: lazy(() => import('@/views/master/AddTaskPriorityMaster')),
        authority: [],
    },
    {
        key: 'master.taskPriority',
        path: `/taskprioritymaster/view`,
        component: lazy(() => import('@/views/master/ViewTaskPriorityMaster')),
        authority: [],
    },
    {
        key: 'master.tasktype',
        path: '/tasktypemaster/list',
        component: lazy(() => import('@/views/master/ListTaskTypeMaster')),
        authority: [],
    },
    {
        key: 'master.tasktype',
        path: '/tasktypemaster/add',
        component: lazy(() => import('@/views/master/AddTaskTypeMaster')),
        authority: [],
    },
    {
        key: 'master.tasktype',
        path: '/tasktypemaster/view',
        component: lazy(() => import('@/views/master/ViewTaskTypeMaster')),
        authority: [],
    },
    {
        key: 'master.resourcerequestreason',
        path: '/resourcerequestreason/list',
        component: lazy(
            () => import('@/views/master/ListResourceRequestReason'),
        ),
        authority: [],
    },
    {
        key: 'master.resourcerequestreason',
        path: '/resourcerequestreason',
        component: lazy(() => import('@/views/master/ResourceRequestReason')),
        authority: [],
    },
    {
        key: 'master.resourcerequestreason',
        path: '/resourcerequestreason/view',
        component: lazy(
            () => import('@/views/master/ViewResourceRequestReason'),
        ),
        authority: [],
    },

    {
        key: 'master.notificationTypeList',
        path: '/notificationtype/list',
        component: lazy(() => import('@/views/master/ListNotificationType')),
        authority: [],
    },
    {
        key: 'master.notificationType',
        path: '/notificationtype',
        component: lazy(() => import('@/views/master/NotificationType')),
        authority: [],
    },
    {
        key: 'master.notificationTypeView',
        path: '/notificationtype/view',
        component: lazy(() => import('@/views/master/ViewNotificationType')),
        authority: [],
    },

    {
        key: 'master.employeeAssesmentCategoryList',
        path: '/employeeassesmentcategory/list',
        component: lazy(
            () => import('@/views/master/ListEmployeeAssesmentCategory'),
        ),
        authority: [],
    },
    {
        key: 'master.employeeAssesmentCategory',
        path: '/employeeassesmentcategory',
        component: lazy(
            () => import('@/views/master/EmployeeAssesmentCategory'),
        ),
        authority: [],
    },
    {
        key: 'master.employeeAssesmentCategoryView',
        path: '/employeeassesmentcategory/view',
        component: lazy(
            () => import('@/views/master/ViewEmployeeAssesmentCategory'),
        ),
        authority: [],
    },

    {
        key: 'master.employeeAssesmentCategoryParamList',
        path: '/employeeassesmentcategoryparam/list',
        component: lazy(
            () => import('@/views/master/ListEmployeeAssesmentCategoryParam'),
        ),
        authority: [],
    },
    {
        key: 'master.employeeAssesmentCategoryParam',
        path: '/employeeassesmentcategoryparam',
        component: lazy(
            () => import('@/views/master/EmployeeAssesmentCategoryParam'),
        ),
        authority: [],
    },
    {
        key: 'master.employeeAssesmentCategoryParamView',
        path: '/employeeassesmentcategoryparam/view',
        component: lazy(
            () => import('@/views/master/ViewEmployeeAssesmentCategoryParam'),
        ),
        authority: [],
    },

    {
        key: 'master.meetingType',
        path: '/meetingtype',
        component: lazy(() => import('@/views/master/MeetingType')),
        authority: [],
    },
    {
        key: 'master.meetingTypeView',
        path: '/meetingtype/view',
        component: lazy(() => import('@/views/master/ViewMeetingType')),
        authority: [],
    },
    {
        key: 'master.meetingTypeList',
        path: '/meetingtype/list',
        component: lazy(() => import('@/views/master/ListMeetingType')),
        authority: [],
    },

    {
        key: 'master.criticalitylevel',
        path: '/criticalitylevel/list',
        component: lazy(() => import('@/views/master/ListCriticalityLevel')),
        authority: [],
    },
    {
        key: 'master.criticalitylevel',
        path: '/criticalitylevel',
        component: lazy(() => import('@/views/master/CriticalityLevel')),
        authority: [],
    },
    {
        key: 'master.criticalitylevel',
        path: '/criticalitylevel/view',
        component: lazy(() => import('@/views/master/ViewCriticalityLevel')),
        authority: [],
    },

    {
        key: 'master.loantypemasterList',
        path: '/loantypemaster/list',
        component: lazy(() => import('@/views/master/ListLoanTypeMaster')),
        authority: [],
    },
    {
        key: 'master.loantypemasterAdd',
        path: '/loantypemaster',
        component: lazy(() => import('@/views/master/LoanTypeMaster')),
        authority: [],
    },
    {
        key: 'master.loantypemasterView',
        path: '/loantypemaster/view',
        component: lazy(() => import('@/views/master/ViewLoanTypeMaster')),
        authority: [],
    },
    {
        key: 'shiftManagement.assignShiftList',
        path: '/shiftmanagement/assignshift/List',
        component: lazy(
            () => import('@/views/shiftManagement/ListAssignShift'),
        ),
        authority: [],
    },
    {
        key: 'shiftManagement.assignShiftList',
        path: '/shiftmanagement/assignshift',
        component: lazy(() => import('@/views/shiftManagement/AssignShift')),
        authority: [],
    },
    {
        key: 'shiftManagement.assignShiftView',
        path: '/shiftmanagement/assignshift/view',
        component: lazy(
            () => import('@/views/shiftManagement/ViewAssignShift'),
        ),
        authority: [],
    },
    {
        key: 'shiftManagement.teamShiftList',
        path: '/shiftmanagement/teamshift/List',
        component: lazy(() => import('@/views/shiftManagement/ListTeamShift')),
        authority: [],
    },
    {
        key: 'employeeAssessmentList',
        path: '/hroperation/employeeassessment/List',
        component: lazy(
            () => import('@/views/empassessment/ListEmployeeAssessment'),
        ),
        authority: [],
    },
    {
        key: 'employeeAssessmentAdd',
        path: '/hroperation/employeeassessment',
        component: lazy(
            () => import('@/views/empassessment/EmployeeAssessment'),
        ),
        authority: [],
    },
    {
        key: 'employeeAssessmentView',
        path: '/hroperation/employeeassessment/view',
        component: lazy(
            () => import('@/views/empassessment/ViewEmployeeAssessment'),
        ),
        authority: [],
    },
    {
        key: 'assignlocationList',
        path: '/assignlocation/list',
        component: lazy(
            () => import('@/views/hroperation/assignlocation/ListWorkLocation'),
        ),
        authority: [],
    },
    {
        key: 'assignlocationAdd',
        path: '/assignlocation',
        component: lazy(
            () => import('@/views/hroperation/assignlocation/WorkLocation'),
        ),
        authority: [],
    },
    {
        key: 'assignlocationView',
        path: '/assignlocation/view',
        component: lazy(
            () => import('@/views/hroperation/assignlocation/ViewWorkLocation'),
        ),
        authority: [],
    },
    {
        key: 'loanapplicationList',
        path: '/loanapplication/list',
        component: lazy(
            () => import('@/views/loanapplication/ListLoanApplication'),
        ),
        authority: [],
    },
    {
        key: 'loanapplicationAdd',
        path: '/loanapplication',
        component: lazy(
            () => import('@/views/loanapplication/LoanApplication'),
        ),
        authority: [],
    },
    {
        key: 'loanapplicationView',
        path: '/loanapplication/view',
        component: lazy(
            () => import('@/views/loanapplication/ViewLoanApplication'),
        ),
        authority: [],
    },
    {
        key: 'teamloanapplicationList',
        path: '/teamloanapplication/list',
        component: lazy(
            () => import('@/views/loanapplication/ListTeamLoanApplication'),
        ),
        authority: [],
    },
    {
        key: 'teamloanapplicationView',
        path: '/teamloanapplication/view',
        component: lazy(
            () => import('@/views/loanapplication/ViewTeamLoanApplication'),
        ),
        authority: [],
    },
    {
        key: 'shiftassignbulkList',
        path: '/shiftassignbulk/List',
        component: lazy(
            () => import('@/views/shiftassignbulk/ShiftAssignBulk'),
        ),
        authority: [],
    },
    {
        key: 'resourcerequestList',
        path: '/hroperation/resourcerequest/List',
        component: lazy(
            () =>
                import(
                    '@/views/hroperation/resourcerequest/ListResourceRequest'
                ),
        ),
        authority: [],
    },
    {
        key: 'resourcerequestAdd',
        path: '/hroperation/resourcerequest',
        component: lazy(
            () => import('@/views/hroperation/resourcerequest/ResourceRequest'),
        ),
        authority: [],
    },
    {
        key: 'resourcerequestView',
        path: '/hroperation/resourcerequest/view',
        component: lazy(
            () =>
                import(
                    '@/views/hroperation/resourcerequest/ViewResourceRequest'
                ),
        ),
        authority: [],
    },
    {
        key: 'teamList',
        path: '/team/list',
        component: lazy(() => import('@/views/self-service/Listteam')),
        authority: [],
    },
    {
        key: 'teamView',
        path: '/team/view',
        component: lazy(() => import('@/views/self-service/Viewteam')),
        authority: [],
    },
    {
        key: 'changeOTP',
        path: `/change-otp`,
        component: lazy(() => import('@/views/ChangeOtp')),
        authority: [],
    },
    {
        key: 'consent',
        path: `/consent`,
        component: lazy(() => import('@/views/Consent')),
        authority: [],
    },
    {
        key: 'pagenotFound',
        path: `/404`,
        component: lazy(() => import('@/views/others/404/PageNotFound')),
        authority: [],
    },
    {
        key: 'forbidden',
        path: `/403`,
        component: lazy(() => import('@/views/others/403/Forbidden')),
        authority: [],
    },
    {
        key: 'master.salaryAdvanceReasonList',
        path: '/salaryadvancereason/list',
        component: lazy(() => import('@/views/master/ListSalaryAdvanceReason')),
        authority: [],
    },
    {
        key: 'master.salaryAdvanceReason',
        path: '/salaryadvancereason',
        component: lazy(() => import('@/views/master/SalaryAdvanceReason')),
        authority: [],
    },
    {
        key: 'master.salaryAdvanceReasonView',
        path: '/salaryadvancereason/view',
        component: lazy(() => import('@/views/master/ViewSalaryAdvanceReason')),
        authority: [],
    },
    {
        key: 'admin.appmenuList',
        path: '/appmenu/list',
        component: lazy(() => import('@/views/admin/ListAppMenu')),
        authority: [],
    },
    {
        key: 'admin.appmenuAdd',
        path: '/appmenu',
        component: lazy(() => import('@/views/admin/AppMenu')),
        authority: [],
    },
    {
        key: 'admin.appmenuView',
        path: '/appmenu/view',
        component: lazy(() => import('@/views/admin/ViewAppMenu')),
        authority: [],
    },
    {
        key: 'admin.emailconfigList',
        path: '/emailconfig/list',
        component: lazy(() => import('@/views/admin/ListEmailConfig')),
        authority: [],
    },
    {
        key: 'admin.emailconfigAdd',
        path: '/emailconfig',
        component: lazy(() => import('@/views/admin/EmailConfig')),
        authority: [],
    },
    {
        key: 'admin.emailconfigView',
        path: '/emailconfig/view',
        component: lazy(() => import('@/views/admin/ViewEmailConfig')),
        authority: [],
    },
    {
        key: 'admin.schedulerconfigList',
        path: '/schedulerconfig/list',
        component: lazy(() => import('@/views/admin/ListSchedulerConfig')),
        authority: [],
    },
    {
        key: 'admin.schedulerconfigAdd',
        path: '/schedulerconfig',
        component: lazy(() => import('@/views/admin/SchedulerConfig')),
        authority: [],
    },
    {
        key: 'admin.schedulerconfigView',
        path: '/schedulerconfig/view',
        component: lazy(() => import('@/views/admin/ViewSchedulerConfig')),
        authority: [],
    },
    {
        key: 'hradmin.greetingList',
        path: '/greeting/list',
        component: lazy(() => import('@/views/hradmin/ListGreeting')),
        authority: [],
    },
    {
        key: 'hradmin.greetingView',
        path: '/greeting/view/:empCode',
        component: lazy(() => import('@/views/hradmin/ViewGreeting')),
        authority: [],
    },
    {
        key: 'admin.appversionList',
        path: '/appversion/list',
        component: lazy(() => import('@/views/admin/ListAppVersion')),
        authority: [],
    },
    {
        key: 'admin.appversionAdd',
        path: '/appversion',
        component: lazy(() => import('@/views/admin/AppVersion')),
        authority: [],
    },
    {
        key: 'admin.appversionView',
        path: '/appversion/view',
        component: lazy(() => import('@/views/admin/ViewAppVersion')),
        authority: [],
    },
    {
        key: 'admin.geoCircularFencingList',
        path: '/geocircularfencing/list',
        component: lazy(() => import('@/views/admin/ListGeoCircularFencing')),
        authority: [],
    },
    {
        key: 'admin.geoCircularFencingAdd',
        path: '/geocircularfencing',
        component: lazy(() => import('@/views/admin/GeoCircularFencing')),
        authority: [],
    },
    {
        key: 'admin.geoCircularFencingView',
        path: '/geocircularfencing/view',
        component: lazy(() => import('@/views/admin/ViewGeoCircularFencing')),
        authority: [],
    },
    {
        key: 'admin.organizationRegistrationList',
        path: '/organizationregistration/list',
        component: lazy(
            () => import('@/views/admin/ListOrganizationRegistration'),
        ),
        authority: [],
    },
    {
        key: 'admin.organizationRegistrationAdd',
        path: '/organizationregistration',
        component: lazy(() => import('@/views/admin/OrganizationRegistration')),
        authority: [],
    },
    {
        key: 'admin.organizationRegistrationView',
        path: '/organizationregistration/view',
        component: lazy(
            () => import('@/views/admin/ViewOrganizationRegistration'),
        ),
        authority: [],
    },
    {
        key: 'admin.faqCategoryList',
        path: '/admin/faqcategory/list',
        component: lazy(() => import('@/views/admin/ListFaqCategory')),
        authority: [],
    },
    {
        key: 'admin.faqCategoryAdd',
        path: '/admin/faqcategory',
        component: lazy(() => import('@/views/admin/FaqCategory')),
        authority: [],
    },
    {
        key: 'admin.faqCategoryView',
        path: '/admin/faqcategory/view',
        component: lazy(() => import('@/views/admin/ViewFaqCategory')),
        authority: [],
    },
    {
        key: 'admin.faqList',
        path: '/admin/faq/list',
        component: lazy(() => import('@/views/admin/ListFaq')),
        authority: [],
    },
    {
        key: 'admin.faqAdd',
        path: '/admin/faq',
        component: lazy(() => import('@/views/admin/Faq')),
        authority: [],
    },
    {
        key: 'admin.faqView',
        path: '/admin/faq/view',
        component: lazy(() => import('@/views/admin/ViewFaq')),
        authority: [],
    },
    {
        key: 'serviceMenu.socialProfileList',
        path: '/profile/socialprofile',
        component: lazy(() => import('@/views/profile/EmployeeSocialProfile')),
        authority: [],
    },
    {
        key: 'serviceMenu.socialProfileView',
        path: '/profile/socialprofile/view',
        component: lazy(
            () => import('@/views/profile/ViewEmployeeSocialProfile'),
        ),
        authority: [],
    },
    {
        key: 'serviceMenu.socialProfile',
        path: '/profile/socialprofile/list',
        component: lazy(
            () => import('@/views/profile/ListEmployeeSocialProfile'),
        ),
        authority: [],
    },

    {
        key: 'helpCenter.supportHub',
        path: '/help-center/support-hub',
        component: lazy(() => import('@/views/help-center/SupportHub')),
        authority: [],
    },
    {
        key: 'helpCenter.article',
        path: '/help-center/article',
        component: lazy(() => import('@/views/help-center/Article')),
        authority: [],
    },
    {
        key: 'helpCenter.userManuals',
        path: '/help-center/user-manuals',
        component: lazy(
            () => import('@/views/help-center/UserManuals/UserManuals'),
        ),
        authority: [],
    },
    {
        key: 'helpCenter.userManualsDetails',
        path: '/help-center/user-manuals/details',
        component: lazy(
            () => import('@/views/help-center/UserManuals/UserManualsDetails'),
        ),
        authority: [],
    },
    {
        key: 'settings.notifications',
        path: '/settings/notifications',
        component: lazy(() => import('@/views/settings/Notification')),
        authority: [],
    },
    {
        key: 'master.paymentMethod',
        path: '/paymentmethod/list',
        component: lazy(() => import('@/views/master/ListPaymentMethod')),
        authority: [],
    },
    {
        key: 'master.paymentMethod',
        path: '/paymentmethod',
        component: lazy(() => import('@/views/master/PaymentMethod')),
        authority: [],
    },
    {
        key: 'master.countryView',
        path: '/paymentmethod/view',
        component: lazy(() => import('@/views/master/ViewPaymentMethod')),
        authority: [],
    },

    {
        key: 'master.orgTypeList',
        path: '/orgtype/list',
        component: lazy(() => import('@/views/master/ListOrgType')),
        authority: [],
    },
    {
        key: 'master.orgType',
        path: '/orgtype',
        component: lazy(() => import('@/views/master/OrgType')),
        authority: [],
    },
    {
        key: 'master.orgTypeView',
        path: '/orgtype/view',
        component: lazy(() => import('@/views/master/ViewOrgType')),
        authority: [],
    },

    {
        key: 'master.empExitReason',
        path: '/empexitreason/list',
        component: lazy(() => import('@/views/master/ListEmpExitReason')),
        authority: [],
    },
    {
        key: 'master.empExitReasonList',
        path: '/empexitreason',
        component: lazy(() => import('@/views/master/EmpExitReason')),
        authority: [],
    },
    {
        key: 'master.empExitReasonView',
        path: '/empexitreason/view',
        component: lazy(() => import('@/views/master/ViewEmpExitReason')),
        authority: [],
    },

    {
        key: 'master.empExitTypeList',
        path: '/empexittype/list',
        component: lazy(() => import('@/views/master/ListEmpExitType')),
        authority: [],
    },
    {
        key: 'master.empExitType',
        path: '/empexittype',
        component: lazy(() => import('@/views/master/EmpExitType')),
        authority: [],
    },
    {
        key: 'master.empExitTypeView',
        path: '/empexittype/view',
        component: lazy(() => import('@/views/master/ViewEmpExitType')),
        authority: [],
    },
    {
        key: 'master.customFieldList',
        path: '/customfield/list',
        component: lazy(() => import('@/views/master/ListCustomFieldMaster')),
        authority: [],
    },
    {
        key: 'master.customField',
        path: '/customfield',
        component: lazy(() => import('@/views/master/CustomFieldMaster')),
        authority: [],
    },
    {
        key: 'master.customFieldView',
        path: '/customfield/view',
        component: lazy(() => import('@/views/master/ViewCustomFieldMaster')),
        authority: [],
    },

    {
        key: 'projectManagementMenu.scrumMeetingAdd',
        path: '/project/scrummeeting/add',
        component: lazy(() => import('@/views/projectmanagement/ScrumMeeting')),
        authority: [],
    },
    {
        key: 'projectManagementMenu.scrumMeetingView',
        path: '/project/scrummeeting/view',
        component: lazy(
            () => import('@/views/projectmanagement/ViewScrumMeeting'),
        ),
        authority: [],
    },

    /** Example purpose only, please remove */
    // {
    //     key: 'singleMenuItem',
    //     path: '/single-menu-view',
    //     component: lazy(() => import('@/views/demo/SingleMenuView')),
    //     authority: [],
    // },
    // {
    //     key: 'addEmployeeItem',
    //     path: '/employees',
    //     component: lazy(() => import('@/views/hrms/EmployeeManagement')),
    //     authority: [],
    // },
    // {
    //     key: 'collapseMenu.item1',
    //     path: '/collapse-menu-item-view-1',
    //     component: lazy(() => import('@/views/demo/CollapseMenuItemView1')),
    //     authority: [],
    // },
    // {
    //     key: 'collapseMenu.item2',
    //     path: '/collapse-menu-item-view-2',
    //     component: lazy(() => import('@/views/demo/CollapseMenuItemView2')),
    //     authority: [],
    // },
    // {
    //     key: 'groupMenu.single',
    //     path: '/group-single-menu-item-view',
    //     component: lazy(() => import('@/views/demo/GroupSingleMenuItemView')),
    //     authority: [],
    // },
    // {
    //     key: 'groupMenu.collapse.item1',
    //     path: '/group-collapse-menu-item-view-1',
    //     component: lazy(
    //         () => import('@/views/demo/GroupCollapseMenuItemView1'),
    //     ),
    //     authority: [],
    // },
    // {
    //     key: 'groupMenu.collapse.item2',
    //     path: '/group-collapse-menu-item-view-2',
    //     component: lazy(
    //         () => import('@/views/demo/GroupCollapseMenuItemView2'),
    //     ),
    //     authority: [],
    // },
    // Process Manager (verticals → activities → steps → owners). Backend: OEDP Portal API.
    {
        key: 'verticals.processes',
        path: '/verticals/processes',
        component: lazy(() => import('@/views/verticals/processes')),
        authority: [],
    },
    {
        key: 'verticals.processes',
        path: '/verticals/processes/:verticalId',
        component: lazy(() => import('@/views/verticals/processes/VerticalProcesses')),
        authority: [],
    },
    {
        key: 'globaluser',
        path: '/globaluser',
        component: lazy(() => import('@/views/GlobalUser')),
        authority: [],
    },
    ...othersRoute,
]
